import React, { useEffect } from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import classNames from 'classnames';

import { setFieldValue } from 'actions';
import { PromotionsOptIn } from 'components/PromotionsOptIn/PromotionsOptIn';
import { TermsAndConditions } from 'components/TermsAndConditions/TermsAndConditions';
import { PROMOTIONS_OPT_IN_FIELD, TERMS_ACCEPTED_FIELD } from 'constants/index';
import type { RootState } from 'reducers/types';
import {
  getFieldValue,
  hasTermsError,
  isBusinessRecipient,
  isRecurringOfferSelected,
} from 'selectors';

import './SenderInformationAcceptGroup.scss';

type PropsFromRedux = ConnectedProps<typeof connector>;

function SenderInformationAcceptGroupComponent({
  areTermsAccepted,
  hasTermsError,
  isBusinessRecipient,
  isPromotionsOptedIn,
  isRecurring,
  setFieldValue,
}: PropsFromRedux) {
  const isPromotionsOptedInStored = isPromotionsOptedIn !== '';

  function handleTermsChange(termsValue: boolean) {
    setFieldValue(TERMS_ACCEPTED_FIELD, termsValue);
  }

  function handlePromotionsOptInChange() {
    setFieldValue(PROMOTIONS_OPT_IN_FIELD, !isPromotionsOptedIn);
  }

  useEffect(() => {
    if (!isBusinessRecipient && !isPromotionsOptedInStored) {
      setFieldValue(PROMOTIONS_OPT_IN_FIELD, true);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      className={classNames({
        'has-terms-error': hasTermsError,
        AcceptGroup: !isBusinessRecipient,
      })}
    >
      {!isBusinessRecipient && (
        <PromotionsOptIn
          defaultChecked={!!isPromotionsOptedIn}
          onChange={handlePromotionsOptInChange}
        />
      )}
      <TermsAndConditions
        data-testid="termsAndConditions"
        defaultChecked={areTermsAccepted}
        onChange={handleTermsChange}
        isRecurring={isRecurring}
      />
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  areTermsAccepted: !!getFieldValue(state, TERMS_ACCEPTED_FIELD),
  hasTermsError: hasTermsError(state),
  isBusinessRecipient: isBusinessRecipient(state),
  isPromotionsOptedIn: getFieldValue(state, PROMOTIONS_OPT_IN_FIELD),
  isRecurring: isRecurringOfferSelected(state),
});

const mapDispatchToProps = {
  setFieldValue,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const SenderInformationAcceptGroup = connector(
  SenderInformationAcceptGroupComponent,
);

export { SenderInformationAcceptGroup };
